const FlexItemGrid = ({ children, style = {}, styles }) => (
    <div style={{ display: 'grid', ...style }} className={styles
        ? styles.grid
        : undefined}>

        { children }
    </div>
)

export default FlexItemGrid